<template>
  <v-form v-model="valid" ref="passwordForm">
    <div class="d-flex my-2">
      <v-text-field
        :label="$t('updatePassword.currentPassword')"
        type="password"
        v-model="form.currentPassword"
        v-validate="'required'"
        data-vv-name="currentPassword"
        :error-messages="errors.collect('currentPassword')"
        required
      ></v-text-field>
    </div>
    <div class="d-flex my-2">
      <v-text-field
        :label="$t('updatePassword.newPassword')"
        type="password"
        v-model="form.password"
        v-validate="'required'"
        data-vv-name="password"
        :error-messages="errors.collect('password')"
        required
      ></v-text-field>
    </div>
    <div class="d-flex my-2">
      <v-text-field
        :label="$t('common.passwordConfirmation')"
        type="password"
        v-model="form.passwordConfirmation"
        v-validate="'required'"
        data-vv-name="passwordConfirmation"
        :error-messages="errors.collect('passwordConfirmation')"
        required
      ></v-text-field>
    </div>
    <div class="form-btn">
      <v-btn outlined @click="submit" class="mr-2" color="primary">{{ $t("button.submit") }}</v-btn>
      <v-btn outlined @click="clear">{{ $t("button.clear") }}</v-btn>
    </div>
    <v-snackbar
      :timeout="3000"
      bottom
      right
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      {{ snackbar.text }}
      <v-btn dark text @click.native="snackbar.show = false" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-form>
</template>

<script>
export default {
  $_veeValidate: {
    validator: "new"
  },
  data: () => ({
    valid: true,
    form: {
      currentPassword: "",
      password: "",
      passwordConfirmation: ""
    },
    snackbar: {
      show: false,
      text: "",
      color: ""
    }
  }),
  mounted() {
    this.$validator.localize("en", this.dictionary);
  },

  methods: {
    submit() {
      this.$store
        .dispatch("updatePassword", this.form)
        .then(() => {
          this.form = {};
          this.$validator.reset();
          this.snackbar = {
            show: true,
            color: "green",
            text: "Your password has been successfully updated."
          };
        })
        .catch(error => {
          let message = error.response.data.errors.full_messages[0];
          this.snackbar = {
            show: true,
            color: "red",
            text: message
          };
        });
    },
    clear() {
      this.form = {};
      this.$validator.reset();
    }
  }
};
</script>

<style lang="stylus" scoped>
.payment-method
  border: 1px solid #eee
</style>
